export const confirmation_modal_title = 'We have received your request!';
export const confirmation_modal_subtitle =
  'Our team is working on your request and will get back to you!';
